module.exports = __webpack_public_path__ + "media/djembe-slap.213b9e80.wav";